import {ListView} from '@github-ui/list-view'
import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemDescriptionItem} from '@github-ui/list-view/ListItemDescriptionItem'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {ListItemTitle} from '@github-ui/list-view/ListItemTitle'
import {Box} from '@primer/react'
import type {ReactElement} from 'react'

interface PropertyDefinition {
  propertyName: string
  propertyValue: ReactElement
}

interface Props {
  definitions: PropertyDefinition[]
}

export function AttestationPropertiesList({definitions}: Props) {
  return (
    <Box data-hpc sx={{border: '1px solid', borderColor: 'border.muted', borderRadius: 2}}>
      <ListView title="Attestation summary" variant="compact">
        {definitions.map(definition => (
          <ListItem
            key={definition.propertyName}
            sx={{
              '&:hover': {
                bg: 'none',
              },
            }}
            title={
              <ListItemTitle
                value={definition.propertyName}
                headerSx={{fontWeight: 600, wordWrap: 'break-word', whiteSpace: 'unset', display: 'block'}}
                containerSx={{
                  width: [120, 120, 256],
                  display: 'flex',
                  alignItems: 'center',
                  px: 2,
                }}
              />
            }
          >
            <ListItemMainContent>
              <ListItemDescription sx={{height: '100%', width: '100%'}}>
                <ListItemDescriptionItem
                  sx={{
                    ml: 2,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    pr: 2,
                  }}
                >
                  {definition.propertyValue}
                </ListItemDescriptionItem>
              </ListItemDescription>
            </ListItemMainContent>
          </ListItem>
        ))}
      </ListView>
    </Box>
  )
}

try{ AttestationPropertiesList.displayName ||= 'AttestationPropertiesList' } catch {}